var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.721,
    height: 29.721,
    viewBox: "0 0 29.721 29.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zur\\xFCck",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_bright",
    "data-name": "Arrow bright",
    transform: "rotate(180 14.36 14.36)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 14.36,
    cy: 14.36,
    r: 14.36,
    fill: "#fff",
    stroke: "#80c9f4",
    transform: "rotate(-180 14.36 14.36)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pfeil",
    transform: "rotate(-180 16.217 33.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4162",
    "data-name": "Gruppe 4162",
    transform: "translate(12.755 44.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9097",
    fill: "#80c9f4",
    d: "M21.338 58.986a.842.842 0 0 1-1.19 1.191L13 53.03a.842.842 0 0 1 0-1.19l7.309-7.308a.842.842 0 0 1 1.19 1.19l-6.713 6.713z",
    "data-name": "Pfad 9097",
    transform: "translate(-12.754 -44.285)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.2a3a2239.svg";
export { ForwardRef as ReactComponent };